const userInfoReducer = (state = {}, action) => {
    switch (action.type) {
        case 'STORE_USER_INFO':
            return action.payload;
        default:
            return state;
    }
};
export default userInfoReducer;